import { Component, OnDestroy, OnInit } from '@angular/core';
import { Field, Form } from '../../../../domain/form.interface';
import { SearchMenuOptions } from '../../../../domain/search-filter.interface';
import { Subject, takeUntil } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { setSelectedForm } from '../../../../infrastructure/store/selectors/form.selector';
import { setSelectedVersion } from '../../../../infrastructure/store/selectors/version.selector';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { ModalComponent } from '../modal/modal.component';
import { ConfirmationDialogData, ModalConfirmationComponent } from '../../../commons/modal-confirmation/modal-confirmation.component';

// Actions
import {
  addForm,
  deleteForm,
  editForm,
  newForm
} from '../../../../infrastructure/store/actions/form.actions';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent  implements OnInit, OnDestroy{

  unsubscribe$ = new Subject();

  elementSelected!: Form; // Element selected to toggle form-version
  forms: Form[] = []; // Forms lis
  formSelected!: Form; // Form selected
  versions: Form[] = [];
  versionSelected!: Form; // Version selected
  field!: Field;
  fields: Field[] = [];
  searchFields: Array<Field> = [];
  showSelectors: boolean = false;

  selected = [];
  rowIndex;

  /*DATA TABLE*/
  columnMode = ColumnMode;
  selectionType = SelectionType;
  // entries = 50;
  selectedData: any[] = [];
  selectedProperties = [
    {
      label: 'Name',
      name: 'name',
    },
    {
      label: 'Type',
      name: 'type',
    },
    {
      label: 'Required',
      name: 'required',
    }
  ];
  showSearchToolbar: boolean = true;
  searchForm!: FormGroup;
  searchOptions: SearchMenuOptions[] = [
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Type',
      value: 'htmlType',
    },    
    {
      label: 'Required',
      value: 'required',
    }
  ];

  /*MODAL*/
  bsModalRef?: BsModalRef;

  constructor(
    private store: Store,
    private modalService: BsModalService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.store
      .pipe(select(setSelectedForm))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          this.formSelected = v;
          if(v) {
            this.elementSelected = v;
            this.showSelectors = true;
            this.fields = [...v.fields]            
          }
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

    this.store
      .pipe(select(setSelectedVersion))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.versionSelected = v;
          if(v) {
            this.elementSelected = v;
            this.showSelectors = false;
            this.fields = [...v.fields]
          }        
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });
  }

  /*get itemSearch() {
    return this.searchForm.get('search');
  }*/

  sortTable(value: any) {}

  toggleShowSearchToolbar() {
    this.showSearchToolbar = !this.showSearchToolbar;
  }

  onSelect({ selected }) {
    console.log('Select Event', selected, this.selected);
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  onActivate(event) {    
    if (event.type === 'click') {
      console.log('Activate Event', event);
      const source = event.event.srcElement.classList[1];

      this.rowIndex = this.fields.findIndex(row => row.id === event.row.id);
      console.log('Original Row Index:',  this.rowIndex);

      if(source == "icon-update") {
        this.update();
      } else if(source == "icon-delete") {
        this.delete();
      }      
    }  
  }

  displayCheck(row) {    
    return this.displayCheck;
  }

  /*CREATE FIELD*/
  create() {
    const initialState: ModalOptions = {
      initialState: {
        title: 'Create Field',
        update: false,
      },
    };

    this.bsModalRef = this.modalService.show(ModalComponent, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      ...initialState,
    });    

  }

  /*EDIT FIELD*/
  update() {
    console.log('this.rowIndex->', this.rowIndex)
    this.field = this.elementSelected.fields[this.rowIndex];
    const initialState: ModalOptions = {
      initialState: {
        title: 'Update Field',
        update: true,
        field: this.field,
        index: this.rowIndex
      },
    };

    this.bsModalRef = this.modalService.show(ModalComponent, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      ...initialState,
    });

  }

  /*DELETE ROW*/
  delete() {
    this.field = this.elementSelected.fields[this.rowIndex];
    
    const dialogData: ConfirmationDialogData = {
      messagePrimary: `Do you really want to delete this Field? `,
      messageSecondary: `This process can not be undone and layout could be modified.`,
      icon: 'delete',
      confirmText: 'Delete',
      cancelText: 'Cancel',
      showCancel: true
    };

    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      height: '250px',
      width: '500px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        // User clicked "Yes, Confirm"
        let tempArray = [...this.fields];
        tempArray.splice(this.rowIndex, 1);        
        this.save(tempArray);
      } else {
        // User clicked "Cancel" or closed the dialog
        console.log('Canceled or closed');
      }
    });
  }

  save(fieldsArray: any) {
    if(this.elementSelected.pk == 'form') {              
      // Update form
      let tempElement = {...this.elementSelected};
      // Remove field in layout
      let updatedLayoutElement = this.deleteObjectsById(tempElement, this.field.id);
      this.store.dispatch(
        editForm({
          form: {
            ...updatedLayoutElement,
            fields: fieldsArray,
          },
        })
      );
    }
  }

  cancel() {
    this.fields = this.elementSelected.fields;
  }

  arraysEqualIgnoreOrder(arr1: any[], arr2: any[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    return arr1.every(element => arr2.includes(element));
  }

  deleteObjectsById(originalObject: any, objectId: string): any {
    if (originalObject && typeof originalObject === 'object') {
      if (Array.isArray(originalObject)) {
        return originalObject
          .filter((item) => typeof item !== 'object' || item.id !== objectId)
          .map((item) => this.deleteObjectsById(item, objectId));
      } else {
        const updatedObject: { [key: string]: any } = {};
        for (const key in originalObject) {
          if (originalObject.hasOwnProperty(key)) {
            updatedObject[key] = this.deleteObjectsById(originalObject[key], objectId);
          }
        }
        return updatedObject;
      }
    } else {
      return originalObject;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

}
